// extracted by mini-css-extract-plugin
export var chatHtmlText = "_ld-2";
export var chatLink = "_ld-0";
export var chatText = "_ld-1";